<template>
  <div id="app">
    <!-- <NavbarStart></NavbarStart> -->
    <GUIde v-if="gUIdeActive" />
    <router-view></router-view>

    <b-modal
      :active.sync="isOnboardingModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
      class="onboarding-modal-wrapper"
    >
      <Onboarding />
    </b-modal>
  </div>

  <!-- <section class="section">
      <div class="container">
        <div class="navlinks">
          <router-link to="/start">Go to Start</router-link>
          <br />
          <router-link to="/start2">Go to the start page</router-link>
          <br />
          <router-link to="/cardlisting">Show cards based on category and role</router-link>
          <br />
          <router-link to="/elements">All Elements</router-link>
        </div>
      </div>
  </section>-->
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
// import NavbarStart from "@/components/NavbarStart.vue";
import Onboarding from "@/components/Onboarding.vue";
import GUIde from "@/components/GUIde.vue";

import { sync, get } from "vuex-pathify";

Vue.use(Vuex);

export default {
  name: "App",
  components: {
    // NavbarStart,
    GUIde,
    Onboarding,
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    isOnboardingModalActive: sync("isOnboardingModalActive"),
    gUIdeActive: get("gUIdeActive"),
  },
};
</script>

<style lang="scss">
@import "@/scss/global.scss";

// $control-radius: 40px;
// $primary: #ff4;
// $primary-invert: findColorInvert($primary);
// $colors: (
//   "primary": (
//     $primary,
//     $primary-invert,
//   ),
// );

#app {
  display: flex;
  flex-flow: column;
  font-family: acumin-pro, sans-serif;
  font-size: 16px;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 0;
  min-height: 100vh;

  margin: 0;
  padding: 0;
  background-color: $background;
  // background-color: red;
}

.navlinks {
  margin-bottom: 24px;
}
@media screen and (max-width: $mobileMenuBreakpoint) {
  .onboarding-modal-wrapper {
    .modal-close {
      &:before {
        background-color: $text-primary;
      }
      &:after {
        background-color: $text-primary;
      }
    }
  }
}
</style>
